import script from "./TutorPayoutsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./TutorPayoutsPage.vue?vue&type=script&setup=true&lang=js"

import "./TutorPayoutsPage.vue?vue&type=style&index=0&id=3b70c14c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b70c14c"]])

export default __exports__